import type { PerformanceMetric } from '@/context/performance';
import { usePerformance } from '@/context/performance';
import { useEffect } from 'react';

export function RecordPerformanceMetric(props: { performanceMetric: PerformanceMetric }) {
  const recordPerformanceMetric = usePerformance();

  useEffect(() => {
    recordPerformanceMetric(props.performanceMetric);
  }, []);

  return null;
}
